import { Wrapper } from '@cma/common'
import { Helmet } from 'react-helmet-async'

export default function Presentations() {
  return (
    <Wrapper>
      <Helmet>
        <title>Presentations - Cloud CMA</title>
      </Helmet>
      <h1>Presentations</h1>
    </Wrapper>
  )
}
